module.exports = __webpack_public_path__ + "media/images/edion/inside_3-4b28a0d95ba626c129dd0e760ee7a9e0.png";